module.exports = __webpack_public_path__ + "img/20.6.CODm.532a3609.png";